var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.561523,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F15353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.863 19.9365L13.237 14.6025L9.989 9.50652H11.053L13.895 14.0005H13.657L16.499 9.50652H17.549L14.301 14.6025L17.703 19.9365H16.639L13.657 15.2045H13.895L10.913 19.9365H9.863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-icon.fcbf185a43ae1b910078dacb08b6c6e7.svg";
export { ForwardRef as ReactComponent };